import { useTranslation } from 'react-i18next';
import SwitchSmall from "../../../components/SwitchSmall";
import { Tooltip } from 'react-tooltip';
import styles from './Filter.module.scss';
import classNames from 'classnames';

export const ExcludeSwitch = ({id, value, onChange, color, direction, isDisabled=false}) => {
  const { t } = useTranslation();
  return (
    <div
      className={styles.switchContainer}
      style={{'flexDirection': direction ? direction : ''}}
      data-tooltip-id={!isDisabled ? `${id}-tooltip` : null}
      data-tooltip-content={!isDisabled ? t('Turn on to exclude selected options') : null}
    >
      <SwitchSmall
        id={id}
        value={value}
        onChange={(bool => onChange(bool))}
        color={color}
        isDisabled={isDisabled}
      />
      <span className={classNames(styles.switchLabel, isDisabled ? styles.switchLabelDisabled : '')} style={{'color': value === true ? '#DC2625' : ''}}>{t('Exclude')}</span>
      {!isDisabled ? <Tooltip id={`${id}-tooltip`} place="top" /> : null}

    </div>
  )
}